import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import DialogBase from '../../../../base/DialogBase/DialogBase';
import { useSuccessAlert } from '../../../../App.hooks';
import { ContentRequestTypeEnum } from '../../../../generated/graphql';

const DELETE_REQUEST = gql`
    mutation deleteContentRequest($id: String!) {
        DeleteRequest(id: $id)
    }
`;

type Props = {
    visible: boolean;
    request: any;
    onClose: () => void;
};

const DeleteRequestDialog = ({ visible, request, onClose }: Props) => {
    const [deleteRequest, { loading }] = useMutation(DELETE_REQUEST);
    const [error, setError] = useState('');
    const setSuccessAlert = useSuccessAlert();
    const isEditRequest = request?.requestType === ContentRequestTypeEnum.EditContent;

    const handleDelete = async () => {
        if (!request?.id) return;
        setError('');
        try {
            await deleteRequest({ variables: { id: request.id } });
            setSuccessAlert('Request deleted.');
            onClose();
        } catch (err: any) {
            setError(
                err?.graphQLErrors?.[0]?.extensions?.message
                || err?.graphQLErrors?.[0]?.message
                || err?.message
                || 'The request could not be deleted.'
            );
        }
    };

    return (
        <DialogBase
            title="Delete Request"
            type="YesNo"
            visible={visible}
            onClose={onClose}
            onYesClick={handleDelete}
            isLoading={loading}
            validationError={error}
        >
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                Permanently delete <strong style={{ color: 'var(--text-primary)' }}>{request?.name ?? 'this request'}</strong>?
            </p>
            {isEditRequest && (
                <p className="text-sm mt-3" style={{ color: 'var(--text-secondary)' }}>
                    The content’s current request reference will also be cleared if it still points to this request.
                </p>
            )}
            <p className="text-xs mt-3" style={{ color: 'var(--danger)' }}>
                This action cannot be undone.
            </p>
        </DialogBase>
    );
};

export default DeleteRequestDialog;
